import { DropdownOption } from "../types";
import { PrimaryDropdownKey } from "../types/user.creation";
import { CREATED_BY_OPTIONS } from "./createdBy";

const dropdownOptions: Record<PrimaryDropdownKey, DropdownOption[]> = {
  gender: [
    { value: "male", label: "Male" },
    { value: "female", label: "Female" },
  ],
  createdBy: [...CREATED_BY_OPTIONS],
  citizenship: [
    { value: "Indian", label: "Indian Profile" },
    { value: "Nri", label: "NRI Profile" },
  ],
  
};

export { dropdownOptions };
